import * as React from 'react';
import { View } from 'react-native';
import Animated, { withTiming, Reanimated3DefaultSpringConfig, withSpring, interpolate, Extrapolation, useSharedValue, useAnimatedProps, useAnimatedStyle, } from 'react-native-reanimated';
import Svg, { Path } from 'react-native-svg';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import { MAX_MIN_INDICATOR_VIEW_HEIGHT } from '../constants';
const CandleMaxPriceIndicator = ({ maxPoint, eachCandleWidth, selectedInfoObj, }) => {
    const didMount = React.useRef(false);
    const styles = useStyles(styleSet);
    const colors = useColors();
    const x = useSharedValue(maxPoint.x);
    const index = useSharedValue((maxPoint.originalX + 1) * eachCandleWidth);
    React.useEffect(() => {
        if (didMount.current) {
            x.value = withTiming(maxPoint.x);
            index.value = withTiming((maxPoint.originalX + 1) * eachCandleWidth);
        }
        else {
            didMount.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eachCandleWidth, maxPoint]);
    const leftViewAnimatedStyles = useAnimatedProps(() => ({
        flex: interpolate(x.value, [0, 0.05, 0.25, 0.5, 0.75, 0.95, 1], [0, 0, 0.25, 0.5, 0.75, 1, 1], Extrapolation.CLAMP),
    }), [x]);
    const rightViewAnimatedStyles = useAnimatedProps(() => ({
        flex: interpolate(x.value, [0, 0.05, 0.25, 0.5, 0.75, 0.95, 1], [1, 1, 0.75, 0.5, 0.25, 0, 0], Extrapolation.CLAMP),
    }), [x]);
    const containerAnimatedStyles = useAnimatedStyle(() => ({
        opacity: withSpring(!selectedInfoObj.value ? 1 : 0, Reanimated3DefaultSpringConfig),
    }), [selectedInfoObj]);
    const markerAnimatedStyles = useAnimatedStyle(() => ({
        left: index.value,
    }), [index]);
    return (<View pointerEvents="none" style={styles.container}>
      <Animated.View style={[styles.flex, containerAnimatedStyles]}>
        <View style={styles.textContainer}>
          <Animated.View style={leftViewAnimatedStyles}/>
          <Text NumbersThin-12 Secondary>
            {maxPoint.priceHigh}
          </Text>
          <Animated.View style={rightViewAnimatedStyles}/>
        </View>
        <Animated.View style={[styles.markerContainer, markerAnimatedStyles]}>
          <Svg>
            <Path strokeWidth={1} d={`M0 18 l0 8`} stroke={colors.elements.secondary}/>
          </Svg>
        </Animated.View>
      </Animated.View>
    </View>);
};
export default React.memo(CandleMaxPriceIndicator);
const styleSet = createStyleSheets(() => ({
    flex: {
        flex: 1,
    },
    container: {
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1,
        position: 'absolute',
        height: MAX_MIN_INDICATOR_VIEW_HEIGHT,
    },
    textContainer: {
        top: 0,
        bottom: 0,
        left: rem(2),
        right: rem(2),
        position: 'absolute',
        flexDirection: 'row',
    },
    markerContainer: {
        top: 0,
        bottom: 0,
        width: rem(2),
        position: 'absolute',
    },
}));
